import angular from 'angular';
import CarouselBannerComponent from './carousel-banner.component';

let CarouselBannerModule = angular.module('shared.components.banners.carouselBannerModules.carouselBanner', [])
  .component('carouselBanner', CarouselBannerComponent);

export default CarouselBannerModule;



/** WEBPACK FOOTER **
 ** ./www/components/shared/components/banners/carousel-banner/carousel-banner.js
 **/